import { appEmit } from "../AppDomain";
import { EventNames } from "../events/Events";

export class ValidationResult {
    fieldName: string;
    message: string;

    constructor(fieldName: string, message: string) {
        this.fieldName = fieldName;
        this.message = message;
    }
}

export class ValidationError extends Error {
    validationResults: Array<ValidationResult>;

    constructor(validationResults: Array<ValidationResult>) {
        super("Validation failed");
        Object.setPrototypeOf(this, ValidationError.prototype);
        this.validationResults = validationResults;
    }
}

export class ValidationResults {
    validationResults: Array<ValidationResult>;

    constructor() {
        // clear any existing validation results
        appEmit(EventNames.validationError, null);
        this.validationResults = [];
    }

    addResult(fieldName: string, message: string) {
        this.validationResults.push(new ValidationResult(fieldName, message));
    }

    addResultIfTrue(condition: boolean, fieldName: string, message: string) {
        if (condition) {
            this.validationResults.push(new ValidationResult(fieldName, message));
        }
        return this;
    }

    throwIfNotValid() {
        if (this.validationResults.length > 0) {
            throw new ValidationError(this.validationResults);
        }
    }
}
